import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {tap} from 'rxjs/operators';
import {BackendService} from '../../services/backend.service';
import {PhotovoltaikcheckAnfrage} from '../anfrage/photovoltaikcheck.anfrage';
import {DebugService} from '../../debug/debug.service';

/**
 * Service for dealing with the backend and make request to the backend.
 */
@Injectable({
  providedIn: 'root'
})
export class PhotovoltaikcheckBackendService extends BackendService {

  /**
   * @inheritDoc
   */
  requestIdName = 'pvc-requestid';

  /**
   * @inheritdoc
   */
  backendDataEndpoint = '/pvc/data/';

  /**
   * remember the last data that we saved to avoid too much performance need on saving requests
   */
  lastData: string;

  /**
   * constructor.
   * @param http
   * @param backendService
   * @param debugService
   */
  constructor(protected http: HttpClient, private backendService: BackendService, protected debugService: DebugService) {
    super(http, debugService);
  }

  /**
   * @inheritDoc
   * this is a small workaround so other components can still access the generic backendservice and will get the real advisor name
   * @param advisor
   */
  setAdvisor(advisor: string) {
    super.setAdvisor(advisor);

    this.backendService.setAdvisor(advisor);
  }

  /**
   * starts the calculation
   * @param anfrage
   * @param requestId
   * @param individually
   */
  result(anfrage: PhotovoltaikcheckAnfrage, requestId: string, individually: boolean = false): Observable<any> {
    // add debug header if we are in debug mode
    const headers = new HttpHeaders({
      'x-api-debug': this.debugService.isDebugOn() ? '1' : '0'
    });

    const url = individually === true ? '/pvc/individually/' : '/pvc/result/';

    // get data from API
    return this.http.post(url + requestId, anfrage, {headers}).pipe(
      tap(data => {
        if (data.debug) {
          this.addDebug(data.debug);
        }
      })
    );
  }
}
